<template>
    <div id="testimoniales" class="container-resizable">
        <h2 class="p-text-center encabezado" style="margin-bottom: 60px;">{{ $t("messages.testimoniosTitle") }}</h2>
        <slider ref="slider" :options="options">
            <slideritem v-for="(item,index) in testimoniales" :key="index" class="slide-item-custom">                
                <div class="card-testimonial">
                    <h2 style="text-align:center">{{ item.especialidad }}</h2>
                    <h3 style="text-align:center">{{ item.name }}</h3>
                    <p class="icono" style="text-align:center"></p>
                    <p class="container-testimonio">{{ item.texto | laPrimeraLetraDelParrafoEnMayuscula }}</p>
                </div>
            </slideritem>
            <div slot="loading">loading...</div>
        </slider>
    </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
    metaInfo: {
    title: 'Home - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Home - QualityCare',
        content: 'QualityCare es un centro de cirugía ambulatoria que le brinda la mejor experiencia medico - paciente. Conozca más sobre nosotros. Estamos ubicados en la ciudad de Bogotá.'
      },
    ],
  },
    name: "TestimonialesSlider",
    components: {
        slider,
        slideritem
    },
    data() {
        return {
            options: {
                currentPage: 0,
                tracking: true,
                thresholdDistance: 100,
                thresholdTime: 300,
                infinite: 4,
                slidesToScroll: 1,
                loop: true,
                speed: 1000,
                autoplay:'5000',
                loopedSlides:4
            },
            testimoniales: [
                {
                    name: "jersson oviedo",
                    especialidad: "médico especialista",
                    texto: "usar los servicios de Quality & Care es lo mejor para mis pacientes, tanto ellos como yo podemos estar seguros de tener a disposición unas instalaciones cuidadas con dedicación y profesionalismo."
                },
                {
                    name: "juan camilo martínez",
                    especialidad: "cirujano maxilofacial",
                    texto: "estoy muy feliz con Quality & Care, su servicio es inigualable y no hay ninguno mejor, son los líderes del mercado."
                },
                {
                    name: "julián jiménez martínez",
                    especialidad: "cirujano plástico",
                    texto: "siempre utilizo los servicios de Quality & Care, su profesionalismo me permite respaldar mi profesión de la manera adecuada y darle a mis pacientes el mejor servicio."
                },
                {
                    name: "jersson oviedo",
                    especialidad: "médico especialista",
                    texto: "usar los servicios de Quality & Care es lo mejor para mis pacientes, tanto ellos como yo podemos estar seguros de tener a disposición unas instalaciones cuidadas con dedicación y profesionalismo."
                },
                {
                    name: "juan camilo martínez",
                    especialidad: "cirujano maxilofacial",
                    texto: "estoy muy feliz con Quality & Care, su servicio es inigualable y no hay ninguno mejor, son los líderes del mercado."
                },
                {
                    name: "julián jiménez martínez",
                    especialidad: "cirujano plástico",
                    texto: "siempre utilizo los servicios de Quality & Care, su profesionalismo me permite respaldar mi profesión de la manera adecuada y darle a mis pacientes el mejor servicio."
                },
                {
                    name: "jersson oviedo",
                    especialidad: "médico especialista",
                    texto: "usar los servicios de Quality & Care es lo mejor para mis pacientes, tanto ellos como yo podemos estar seguros de tener a disposición unas instalaciones cuidadas con dedicación y profesionalismo."
                },
                {
                    name: "juan camilo martínez",
                    especialidad: "cirujano maxilofacial",
                    texto: "estoy muy feliz con Quality & Care, su servicio es inigualable y no hay ninguno mejor, son los líderes del mercado."
                },
                {
                    name: "julián jiménez martínez",
                    especialidad: "paciente",
                    texto: "siempre utilizo los servicios de Quality & Care, su profesionalismo me permite respaldar mi profesión de la manera adecuada y darle a mis pacientes el mejor servicio."
                }
            ]
        }
    },    
}
</script>

<style scoped>
.encabezado{
    color: #083078;
    font-size: 40px;
    font-weight: bolder;
}
.container-resizable {
    background-color: #f1f1f1;
    justify-content: space-around;
}

.card-testimonial {
    background-color: #fbfbfb;
    box-shadow: 0 0 6px 0 #cecece;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding: 20px;    
    width: 100%;
    min-height: 300px;
    quotes: "\201C" "\201D";
}

.card-testimonial h2 {
    font-family: sans-serif;
    font-size: 16px;
    text-transform: capitalize;
    margin: 0px;
    padding: 0px;
    color: black;
}

.card-testimonial h3 {
    color: #356cd3;
    font-size: 18px;
    text-transform: uppercase;
    margin: 0px;
    padding: 0px;
    margin-bottom: 13px;
    padding-bottom: 5px;
}

.card-testimonial h3:after {
    border-bottom: 1px #2b86d9 solid;
    display: block;
    content: '';
    margin-left: 40%;
    width: 20%;
    padding-top: 10px;
}

.card-testimonial .icono:before {
    content: open-quote;
    display: block;
    height: 0;
    line-height: 0;
    left: 0px;
    position: relative;
    top: 20px;
    color: #2b86d9;
    font-size: 2em;
    padding: 10px;
}
.card-testimonial .container-testimonio{
    font-size: 14px;
    text-align: justify;
    color: #333;
    padding: 10px;    
    white-space: pre-line;
}

.slide-item-custom{
    width: 23.5%;
    margin-right: 2%;
}

@media (max-width: 1700px) {
    .slide-item-custom{
        width: 31.5%;
        margin-right: 2%;
    }
}

@media (max-width: 1400px) {
    .slide-item-custom{
        width: 48%;
        margin-right: 2%;
    }
}

@media (max-width: 1100px) {
    .slide-item-custom{
        width: 98%;
        margin-right: 2%;
    }
}

@media (max-width: 910px) {
    .container-resizable {
        padding: 30px 10px;
    }
}
</style>